import React, { FC, useRef, useState } from 'react';
import Slider from 'react-slick';
import styled from 'styled-components';
import { useDevice } from '../../constants/device/device';
import media from '../../constants/media';
import theme from '../../constants/theme';
import { IImageCard } from '../../interfaces/umbracoNodes/contentSlices';
import ImageCard from '../cards/imageCard';

interface Props {
	cards: IImageCard[];
}

const SliderWrapper = styled.div`
	position: relative;
	margin: 56px 30px 0 -8px;

	.slick-list {
		overflow: visible;
	}

	.slick-track {
		display: flex;

		> div {
			height: auto;
			float: none;

			> div,
			> div > a {
				height: 100%;
			}
		}
	}

	${media.tablet`
		margin: 56px -8px 0;
	`}
`;

const CardWrapper = styled.div`
	padding-inline: 8px;
	height: 100%;
	display: flex !important;
`;

const Dots = styled.ul`
	display: flex;
	align-items: center;
	justify-content: center;
	margin: 28px 0 0 30px;
	padding: 0;
	list-style-type: none;

	${media.tablet`
		margin: 28px 0 0;
	`}
`;

const Dot = styled.li<{
	active: boolean;
}>`
	margin-inline: 4px;
	width: ${({ active }) => (active ? '24px' : '8px')};
	height: 8px;
	border-radius: 4px;
	background: ${({ active }) => (active ? theme.colorsV2.grey5 : theme.colorsV2.grey4)};
	transition: 0.4s ease;
`;

const ServiceImageCardsSlider: FC<Props> = ({ cards }) => {
	const sliderRef = useRef(null);
	const [activeIndex, setActiveIndex] = useState(0);
	const { currentDevice } = useDevice();
	const slidesToShow = currentDevice === 'mobile' ? 1 : 2;

	const sliderSettings = {
		dots: false,
		arrows: false,
		infinite: false,
		speed: 400,
		slidesToShow: slidesToShow,
		slidesToScroll: 1,
		beforeChange: (_: number, nextIndex: number) => {
			setActiveIndex(nextIndex);
		},
		draggable: true,
		autoplay: false,
	};

	return (
		<SliderWrapper>
			<Slider {...sliderSettings} ref={sliderRef}>
				{cards.map((card, index) => (
					<CardWrapper key={index}>
						<ImageCard content={card} />
					</CardWrapper>
				))}
			</Slider>
			<Dots>
				{[...Array(cards.length + 1 - slidesToShow)].map((_, index) => (
					<Dot key={index + 1} active={index === activeIndex} />
				))}
			</Dots>
		</SliderWrapper>
	);
};

export default ServiceImageCardsSlider;
